import * as Sentry from "@sentry/react";

/**
 * Log an exception with structured context so the dashboard is actually helpful.
 *
 * @param {any} error - The error/exception object.
 * @param {Object} options - Additional context.
 * @param {string} [options.area] - Logical area or function where it happened.
 * @param {Object} [options.tags] - Key-value pairs turned into Sentry tags.
 * @param {Object} [options.extra] - Key-value pairs captured as extra payload.
 * @param {('error'|'warning'|'info'|'debug'|'fatal')} [options.level] - Severity level (defaults to "error").
 */
export function logException(
  error,
  { area, tags = {}, extra = {}, level = "error" } = {}
) {
  Sentry.withScope((scope) => {
    scope.setLevel(level);

    if (area) {
      scope.setTag("area", area);
    }

    // Attach any provided tags / extra data for quick filtering.
    Object.entries(tags).forEach(([key, value]) => scope.setTag(key, value));
    Object.entries(extra).forEach(([key, value]) => scope.setExtra(key, value));

    Sentry.captureException(error);
  });
}

/**
 * Capture a message (non-exception event) with helpful context.
 */
export function logMessage(
  message,
  { area, tags = {}, extra = {}, level = "info" } = {}
) {
  Sentry.withScope((scope) => {
    scope.setLevel(level);

    if (area) {
      scope.setTag("area", area);
    }

    Object.entries(tags).forEach(([key, value]) => scope.setTag(key, value));
    Object.entries(extra).forEach(([key, value]) => scope.setExtra(key, value));

    Sentry.captureMessage(message);
  });
}
